import React from "react";
import { NavLink } from "react-router-dom";

import { all_routes } from "../../../router/all_routes";

interface ProjectSidebarProps {
  projectKey: string;
}

const NAV_LINKS = [
  { to: all_routes.projectOverview, label: "Overview", icon: "ti ti-layout-dashboard" },
  { to: all_routes.projectBoard, label: "Board", icon: "ti ti-layout-kanban" },
  { to: all_routes.projectBacklog, label: "Backlog", icon: "ti ti-list-details" },
  { to: all_routes.projectIssues, label: "Issues", icon: "ti ti-bug" },
  { to: all_routes.projectReports, label: "Reports", icon: "ti ti-chart-dots-3" },
  { to: all_routes.projectGantt, label: "Gantt", icon: "ti ti-calendar-stats" },
];

const SETTINGS_LINKS = [
  { to: all_routes.projectSettings, label: "Details", icon: "ti ti-file-settings" },
  { to: all_routes.projectSettingsMembers, label: "Members", icon: "ti ti-users-group" },
  { to: all_routes.projectSettingsBoard, label: "Board", icon: "ti ti-columns" },
  { to: all_routes.projectSettingsLabels, label: "Labels", icon: "ti ti-tags" },
  { to: all_routes.projectSettingsCustomFields, label: "Custom Fields", icon: "ti ti-forms" },
  { to: all_routes.projectSettingsComponents, label: "Components", icon: "ti ti-puzzle" },
  { to: all_routes.projectSettingsVersions, label: "Versions", icon: "ti ti-package" },
  { to: all_routes.projectSettingsResolutions, label: "Resolutions", icon: "ti ti-circle-check" },
];

const ProjectSidebar: React.FC<ProjectSidebarProps> = ({ projectKey }) => {
  const buildPath = (template: string) =>
    template.replace(":projectKey", projectKey);

  return (
    <div
      className="card mb-3 border-0"
      style={{
        borderRadius: 14,
        boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
        position: "sticky",
        top: 80,
      }}
    >
      <div className="card-body bg-white rounded-3 p-3">
        {/* Section Label */}
        <div
          className="fw-semibold px-2 mb-2"
          style={{
            fontSize: 10.5,
            textTransform: "uppercase",
            letterSpacing: 1,
            color: "#94a3b8",
          }}
        >
          Navigation
        </div>

        <ul className="nav nav-pills flex-column gap-1 mb-2">
          {NAV_LINKS.map((link) => (
            <li className="nav-item" key={link.to}>
              <NavLink
                to={buildPath(link.to)}
                end={link.to === all_routes.projectOverview}
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center gap-2 ${isActive ? "active" : ""
                  }`
                }
                style={({ isActive }) => ({
                  borderRadius: 8,
                  padding: "8px 12px",
                  fontSize: 13,
                  fontWeight: 500,
                  whiteSpace: "nowrap" as const,
                  transition: "all 0.2s ease",
                  background: isActive
                    ? "linear-gradient(135deg, #eff6ff, #dbeafe)"
                    : "transparent",
                  color: isActive ? "#1d4ed8" : "#475569",
                  borderLeft: isActive
                    ? "3px solid #3b82f6"
                    : "3px solid transparent",
                })}
              >
                <i className={link.icon} style={{ fontSize: 17, flexShrink: 0, width: 20, textAlign: "center" }} />
                <span>{link.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <hr className="my-2" style={{ borderColor: "#f1f5f9" }} />

        {/* Settings Section */}
        <div
          className="fw-semibold px-2 mb-2"
          style={{
            fontSize: 10.5,
            textTransform: "uppercase",
            letterSpacing: 1,
            color: "#94a3b8",
          }}
        >
          Settings
        </div>

        <ul className="nav nav-pills flex-column gap-1">
          {SETTINGS_LINKS.map((link) => (
            <li className="nav-item" key={link.to}>
              <NavLink
                to={buildPath(link.to)}
                end={link.to === all_routes.projectSettings}
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center gap-2 ${isActive ? "active" : ""
                  }`
                }
                style={({ isActive }) => ({
                  borderRadius: 8,
                  padding: "8px 12px",
                  fontSize: 13,
                  fontWeight: 500,
                  whiteSpace: "nowrap" as const,
                  transition: "all 0.2s ease",
                  background: isActive
                    ? "linear-gradient(135deg, #eff6ff, #dbeafe)"
                    : "transparent",
                  color: isActive ? "#1d4ed8" : "#475569",
                  borderLeft: isActive
                    ? "3px solid #3b82f6"
                    : "3px solid transparent",
                })}
              >
                <i className={link.icon} style={{ fontSize: 17, flexShrink: 0, width: 20, textAlign: "center" }} />
                <span>{link.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProjectSidebar;
